<template>
	<input type="text" :value='message' @change='inputting' @input='inputting'>
</template>

<script>
import Flatpickr from './assets/flatpickr'

export default {
	props: {
    options: {
      type: Object,
      default: () => {
      	return {}
      }
    },
    message: {
    	type: String,
    	default: () => {
    		return ''
    	}
    }
  },
	methods: {
		inputting (e) {
			this.$emit('input', e.target.value)
		}
	},
  mounted () {
    new Flatpickr(this.$el, this.options)
  }
}
</script>

<style scoped>
  @import url('./assets/flatpickr.base16_flat.min.css');
</style>


// WEBPACK FOOTER //
// vue-flatpickr-base16.vue?6a679d10